/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

interface BuildAuthRedirectUrlOptions {
	authPath: string;
	redirectUrl: string;
	locale?: string;
}

export const buildAuthRedirectUrl = ({ authPath, redirectUrl, locale }: BuildAuthRedirectUrlOptions): string => {
	const hashIndex = authPath.indexOf("#");
	const hash = hashIndex === -1 ? "" : authPath.slice(hashIndex);
	const pathAndQuery = hashIndex === -1 ? authPath : authPath.slice(0, hashIndex);
	const queryIndex = pathAndQuery.indexOf("?");
	const path = queryIndex === -1 ? pathAndQuery : pathAndQuery.slice(0, queryIndex);
	const search = new URLSearchParams(queryIndex === -1 ? "" : pathAndQuery.slice(queryIndex + 1));
	search.set("redirectUrl", redirectUrl);
	if (locale) search.set("lang", locale);
	return `${path}?${search}${hash}`;
};
